<template>
    <div style="width: 100%;">
   <div class="header-main" style="width: 100%;">
    <div class="hm-left ">
      <div>
        <div class="bread-crumb"></div>
        <div class="header-main__title-wrap">
          <h1 class="header-main__title">Задачи</h1>
          <div class="header-main__review"></div>
        </div>
      </div>
    </div>

    <div class="hm-right">
      <div class="btn-wrapper btn-wrapper_group new">
        
        <router-link to="/bonus" class="btn_ms btn ">
          <div class="">Бонусы</div>
        </router-link>
        <router-link to="/" class="btn_ms m0 btn" >
          <div class="">Товары</div>
        </router-link>
          <router-link to="/orders" class="btn_ms m0 btn" >
          <div class="">Заказы</div>
        </router-link>
       <router-link to="/alltask" class="btn_ms m0 btn">
          <div class="">Задачи</div>
        </router-link>   
                
      </div>
    </div>
  </div>
  <div class="calendar-app">
    <!-- Сайдбар: слева – задачи и заказы -->
    <div class="sidebar">
  <!-- Вкладки для переключения -->
  <div class="tabs">
    <button 
      :class="{ active: activeTab === 'tasks' }" 
      @click="activeTab = 'tasks'">
      Задачи
    </button>

    <div v-if="tasks.length > 0">
          <span>{{ activeTasks.length }}</span>
          <span>/</span>
          <span>{{ inactiveTasks.length }}</span>
        </div>
    
  </div>

  

<!--<button @click="openNewTaks" type="button" class="neword omnica-button omnica-button_secondary omnica-button_sm omnica-button_default omnica-button_has-leading-icon omnica-button_ellipsis">
  <span class="omnica-button__inner">
    <span class="omnica-button__icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" title="" class="UiIcon-icon-2pR-">
        <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16zm1-9h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H13v2.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V13H8.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H11V8.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V11z" fill-rule="evenodd" clip-rule="evenodd"></path>
      </svg>
    </span>
    <span class="omnica-button__text"> Создать задачу </span>
  </span>
</button>-->

  <!-- Блок задач -->
  <div v-if="activeTab === 'tasks'">
    <!-- Блок Калькуляции -->
    <div class="calculation-block">
      <!-- Заголовок: "Калькуляция (кол-во)" и общая сумма -->
      <div class="calculation-header">
        <span class="calculation-title-header">
          {{ formatDateToYMDcustom(currentDate) }}
        </span>
        
      
      </div>

      <!-- Список карточек задач (именно на выбранный день) -->

      
      <div class="taskitem" v-for="task in getCurTasks(tasks, currentDate)"> 
                        

                        <div v-if="task.viewed === '1'"  @click="changeTask(task.id, task.taskOrderId)">
                            <div class="icontask act">
                                <svg>
                                        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="checkmark_circle"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM10.73 15.35L16.35 9.73C16.5341 9.53685 16.5341 9.23315 16.35 9.04L15.82 8.51C15.6256 8.31943 15.3144 8.31943 15.12 8.51L10.38 13.25L8.88 11.76C8.78927 11.6633 8.66259 11.6085 8.53 11.6085C8.39741 11.6085 8.27073 11.6633 8.18 11.76L7.65 12.29C7.55534 12.3839 7.5021 12.5117 7.5021 12.645C7.5021 12.7783 7.55534 12.9061 7.65 13L10.03 15.35C10.1207 15.4467 10.2474 15.5015 10.38 15.5015C10.5126 15.5015 10.6393 15.4467 10.73 15.35Z"/></symbol>
                                        <use xlink:href="#checkmark_circle"></use>
                                    </svg>
                                </div>
                            </div>

                            <div v-else>
                                <div :class="['icontask', { act: activeTaskId === task.id }]" @click="updatTask(task.id, OrderIdtsk)"> 
                                    <svg :style="{display: activeTaskId === task.id ? 'none' : 'block'}">
                                        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="checkmark_circle_empty"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM4 12C4 16.4183 7.58172 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"/></symbol>
                                        <use xlink:href="#checkmark_circle_empty"></use>
                                    </svg>
                                    <svg :style="{ display: activeTaskId === task.id ? 'block' : 'none' }">
                                        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="checkmark_circle"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM10.73 15.35L16.35 9.73C16.5341 9.53685 16.5341 9.23315 16.35 9.04L15.82 8.51C15.6256 8.31943 15.3144 8.31943 15.12 8.51L10.38 13.25L8.88 11.76C8.78927 11.6633 8.66259 11.6085 8.53 11.6085C8.39741 11.6085 8.27073 11.6633 8.18 11.76L7.65 12.29C7.55534 12.3839 7.5021 12.5117 7.5021 12.645C7.5021 12.7783 7.55534 12.9061 7.65 13L10.03 15.35C10.1207 15.4467 10.2474 15.5015 10.38 15.5015C10.5126 15.5015 10.6393 15.4467 10.73 15.35Z"/></symbol>
                                        <use xlink:href="#checkmark_circle"></use>
                                    </svg>
                                </div>
                            </div>

                    
                        
                        

                        <div class="bubble-item__body">
                          <div @click="openSidebar(task.id, task.dueDate, task.taskText, task.description, task.performer, task.taskOrder, task.taskOrderId)">
                          <div class="duedat">

                            <span>До {{ task.dueDate }}</span>

                              <span 
                                      v-if="task.viewed !== '1' && isOverdue(task.dueDate)" 
                                      class="erorp"
                                    >
                                     Просрочена
                              </span>

                          </div>
                            <div class="bubble-cont">
                                <div :class="{'complited': task.viewed === '1'}">
                                    {{ task.taskText }} 
                                </div>
                                
                                <div class="bubble-item__comment">
                                        <svg>
                                            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="message_outlined"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2H18C20.2091 2 22 3.79086 22 6V14C22 16.2091 20.2091 18 18 18H8C7.19856 17.9847 6.42433 18.2908 5.85 18.85L2.85 21.85C2.75833 21.9451 2.63212 21.9992 2.5 22C2.22386 22 2 21.7761 2 21.5V6C2 3.79086 3.79086 2 6 2ZM20 6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V17.88L4.46 17.46C5.39951 16.5229 6.67301 15.9976 8 16H18C19.1046 16 20 15.1046 20 14V6Z"/></symbol>
                                            <use xlink:href="#message_outlined"></use>
                                        </svg>
                                </div>

                               


                                
                            </div>

                            </div>

                            <div class="bubble-item__row" @click="OpenOrder(task.taskOrderId)">
                                <div class="buble-info">

                                    <div class="fllink">
                                        <svg>
                                            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="order"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.73 7.12L20.59 6.87C20.4094 6.56769 20.1547 6.31643 19.85 6.14L13.14 2.27C12.8362 2.09375 12.4913 2.00062 12.14 2H11.85C11.4987 2.00062 11.1538 2.09375 10.85 2.27L4.14 6.15C3.83697 6.32526 3.58526 6.57697 3.41 6.88L3.27 7.13C3.09375 7.43384 3.00062 7.77874 3 8.13V15.88C3.00062 16.2313 3.09375 16.5762 3.27 16.88L3.41 17.13C3.58979 17.4295 3.84049 17.6802 4.14 17.86L10.86 21.73C11.1623 21.9099 11.5082 22.0033 11.86 22H12.14C12.4913 21.9994 12.8362 21.9063 13.14 21.73L19.85 17.85C20.156 17.6787 20.4087 17.426 20.58 17.12L20.73 16.87C20.9041 16.5653 20.9971 16.221 21 15.87V8.12C20.9994 7.76874 20.9063 7.42384 20.73 7.12ZM11.85 4H12.14L18 7.38L15.9152 8.58224L10.0299 5.05161L11.85 4ZM8.04951 6.19584L13.9329 9.72535L12 10.84L6 7.38L8.04951 6.19584ZM13 19.5L18.85 16.12L19 15.87V9.11L13 12.58V19.5ZM11 12.5L5 9V16L11 19.5V12.5Z"/></symbol>
                                            <use xlink:href="#order"></use>
                                        </svg>
                                        
                                        <div class="orderid">{{ task.taskOrder }}</div>

                                    </div>


                                </div>
                                
                            </div>
                        </div>

                        
                        

                    </div>




    </div>
  </div>

  <!-- Блок заказов -->
  <div v-if="activeTab === 'orders'">
    <div class="orders-list">
      <h3>Список заказов</h3>
      <!-- Фильтры -->
      <div class="filter-buttons">
        <button
          :class="{ active: activeStatus === '' }"
          @click="filterByStatus('')"
          style="background:#d6eaff"
        >
          Все
        </button>
        <button
          v-for="(status, index) in visibleFilterStatuses"
          :key="status.value"
          :class="{ active: activeStatus === status.value }"
          @click="filterByStatus(status.value)"
          :style="{ background: status.color }"
        >
          {{ status.label }}
        </button>
        <button
          v-if="!showAllFilterButtons && filterStatuses.length > 6"
          @click="showAllFilterButtons = true"
        >
          Показать ещё
        </button>
      </div>

      <!-- Карточки заказов -->
      <div class="orders-grid">
        <div
          class="order-card"
          v-for="order in orders"
          :key="order.id"
          draggable="true"
          @dragstart="onDragStartFromList($event, order)"
        >

        <div class="calculation-block-zakaz-sto">
          <div class="block_zakaz" style="border-left:none">
            <span class="label_span">Заказ:</span>
            <div>{{ order.number }}</div>
          </div>
          <div class="block_zakaz">
            <span class="label_span">Телефон:</span>
            <div>{{ order.phone }}</div>
          </div>
          <div class="block_zakaz_all" v-if="order.managerComment">
            <span class="label_span">Комментарий:</span>
            <div>{{ order.managerComment }}</div>
          </div>

      <div class="block_zakaz_all_select" >
        <span class="label_span">Статус:</span>
        <!-- Кастомный селект для смены статуса -->
        <CustomSelect
          :order="order"
          :statuses="statuses"
          @update:orderStatus="order.status = $event"
        />
        </div>
      </div>


          
          
          <!-- Tooltip с дополнительной информацией -->
          <div class="tooltip">
            <div><strong>Марка авто:</strong> {{ order.car || 'Не указано' }}</div>
            <div><strong>Год выпуска:</strong> {{ order.year || 'Не указан' }}</div>
            <div>
              <strong>Что нужно сделать:</strong>
              {{ order.taskDescription || order.customerComment || 'Нет описания' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



    <!-- Правая часть – календарь -->
    <div class="calendar-container">
      <div class="calendar-header">

        <button class="nav-btn" @click="goPrev">‹</button>
        <span class="header-current">{{ displayLabel }}</span>
        <button class="nav-btn" @click="goNext">›</button>
      </div>
      
      <MonthViewForTasks
        v-if="viewMode === 'month'"
        :currentDate="currentDate"
        :tasks="tasks"
        @dayClick="drillDownToDay"
        @daySelect="selectDay"
        @taskClick="openEditModal"
        @taskDropped="handleTaskDropped"
      />


      <!--<OmnicaSidebar
      :visible="sidebarVisible"
      :managers="managers"
      @close="closeSidebar"
      @submit="handleSubmit"
    />-->



      <OmnicaEditTask
        :taskid="taskid"
        :visible="isVisible"
        :duedata="duedata"
        :description="description"
        :tasktext="tasktext"
        :performer="performer"
        :taskorder="taskorder"
        :taskorderid="taskorderid"
        :managers="managers"
        @close="close()"
      />





    </div>
  </div>
</div>

</template>

<script>import { ORDERS_API_BASE } from '@/config/api';

import axios from "axios";
import MonthViewForTasks from "./MonthViewForTasks.vue";
import OmnicaSidebar from "./OmnicaSidebar.vue";
import WeekView from "./WeekView.vue";
import DayView from "./DayView.vue";
import CustomSelect from "@/components/CustomSelect.vue"; 

import OmnicaEditTask from "./OmnicaEditTask.vue";

// Импортируем flatPickr и его стили
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Russian } from "flatpickr/dist/l10n/ru.js";
import { sortManagersByLabel } from '@/constants/sortManagers';

export default {
  name: "AllTask",
  components: { MonthViewForTasks, WeekView, DayView, flatPickr, CustomSelect, OmnicaEditTask, OmnicaSidebar  },


    
  data() {
    return {
      sidebarVisible: false,
      managers: [],
      isVisible: false,
      taskid: "",
      duedata: "",
      tasktext: "",
      description: "",
      performer: "",
      taskorder:"",
      taskorderid: "",
      viewMode: "month",
      currentDate: new Date(),
      tasks: [],
      modalAddVisible: false,
      modalEditVisible: false,
      modalNewOrderVisible: false, // для нового заказа
      activeTab: 'tasks',
      selectedDateInput: new Date(), 
      newTaskText: "",
      newTaskTitle: "",
      editingTask: null,
      editTaskText: "",
      editTaskTitle: "",
      editTaskOrder: "",
      orders: [],
      filterStatuses: [],
      serviceModalVisible: false, // новое: видимость модального окна выбора услуг
    serviceList: [],
    children: [],
    statuses: [],
    tempSelectedServices: [],
      selectedServices: [],

      // Новые данные для модального окна "Новый заказ"
      newOrderTitle: "",
      newOrderDateInput: new Date(),
      newOrderPhone: "",
      newOrderCar: "",
      newOrderComment: "",
      newOrderName:"",




      expandedServices: {}, // Объект для хранения состояния раскрытия категорий
      activeStatus: "",
      showAllFilterButtons: false,
      page: 1,
      perPage: 50,
      apiEndpoint: "",
      // Новые поля для телефона и машины:
    newTaskPhone: "",
    newTaskCar: "",
      droppedOrder: null,
      // Переменные для редактирования даты/времени в модалках
      newTaskTimeInput: "08:00",
      editDateInput: "",
      editTaskTimeInput: "08:00",
      // Добавляем конфигурацию для flatPickr
      flatpickrConfig: {
        locale: Russian, // Русификация
        enableTime: true, // Включаем выбор времени
        dateFormat: "d.m.Y H:i", // Формат отображения даты и времени
        time_24hr: true  // 24-часовой формат
      }
    };
  },

  


  computed: {
    
    

activeTasks() {
  // Добавляем поддержку "0", так как бэкенд использует "1" для прочитанных
  return this.tasks.filter(task => task.viewed === "false" || task.viewed === "0" || !task.viewed);
},
inactiveTasks() {
  return this.tasks.filter(task => task.viewed === '1' || task.viewed === "true");
},


    currentUser() {
      return this.$store && this.$store.state.user
        ? this.$store.state.user
        : { id: 1, label: "Я" };
    },
    displayLabel() {
      const d = this.currentDate;
      if (this.viewMode === "month") {
        return d.toLocaleString("ru", { month: "long", year: "numeric" });
      } else if (this.viewMode === "week") {
        const start = new Date(d);
        let dayOfWeek = start.getDay() || 7;
        if (dayOfWeek !== 1) {
          start.setDate(start.getDate() - (dayOfWeek - 1));
        }
        const end = new Date(start);
        end.setDate(start.getDate() + 6);
        const options = { day: "numeric", month: "short", year: "numeric" };
        return `${start.toLocaleDateString("ru", options)} – ${end.toLocaleDateString("ru", options)}`;
      } else {
        return d.toLocaleDateString("ru", { day: "numeric", month: "long", year: "numeric" });
      }
    },
    currentDayTasks() {
      const ymd = this.formatDateToYMD(this.currentDate);
      return this.tasks.filter(task => task.date === ymd);
    },
    visibleFilterStatuses() {
      return this.showAllFilterButtons ? this.filterStatuses : this.filterStatuses.slice(0, 6);
    },
    timeOptions() {
      const options = [];
      for (let h = 8; h < 19; h++) {
        for (let m = 0; m < 60; m += 30) {
          const hh = String(h).padStart(2, "0");
          const mm = String(m).padStart(2, "0");
          options.push(`${hh}:${mm}`);
        }
      }
      options.push("19:00");
      return options;
    }
  },

  created() {
      this.fetchManagers(); 
  },


  methods: {
    OpenOrder(orderId){
      this.$router.push({
          name: 'OrderEdit',
          params: { orderId }
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') throw err;
        });
    },
    openNewTaks(){
      this.sidebarVisible = true;
    },
    closeSidebar(){
      this.sidebarVisible = false;
    },
    NewformatDate(curdate) {
        const date = new Date(curdate);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Месяцы начинаются с 0
        const year = date.getFullYear();
        return `${day}.${month}.${year}`; // Форматируем как "дд.мм.гггг"
    },
getCurTasks(tasks, curdate){
  const ncurdate = this.NewformatDate(curdate); // Форматируем текущую дату
  return tasks.filter(task => {
    if (!task.dueDate) return false; 
    
    const taskDate = task.dueDate.split(' ')[0]; // Получаем только дату без времени
    return ncurdate === taskDate;
  });
},
    async changeTask(tasId, OrderIdtsk) {
        try { 
            const response = await fetch('https://manager.1akb.by/updateTaskFields', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id: tasId, viewed: 'false' }) // Обновляем поле viewed
            });

            if (!response.ok) {
                throw new Error(`Ошибка: ${response.statusText}`);
            }

            console.log(`Задача ${tasId} отмечена как не просмотренная`); 
            //this.activeTaskId = this.activeTaskId === tasId ? null : tasId;

            await this.fetchTasks();


        } catch (error) {
            console.error("Ошибка при обновлении viewed:", error);
        }
      },
      async updatTask(taskId, OrderIdtsk) {
        try {
            const response = await fetch('https://manager.1akb.by/updateTaskFields', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id: taskId, viewed: 1 }) // Обновляем поле viewed
            });

            if (!response.ok) {
                throw new Error(`Ошибка: ${response.statusText}`);
            }

            console.log(`Задача ${taskId} отмечена как просмотренная`); 
            //this.activeTaskId = this.activeTaskId === taskId ? null : taskId;
            
            // Загружаем обновленный список
            await this.fetchTasks();

        } catch (error) {
            console.error("Ошибка при обновлении viewed:", error);
        }
    },
   
    isOverdue(dueDateStr) {
        // Преобразуем строку в формат, понятный для Date
        const isoDate = dueDateStr.replace(
          /(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2})/,
          '$3-$2-$1T$4:$5'
        );
        const dueDate = new Date(isoDate);
        const now = new Date();
        return dueDate < now;
      },

    fetchManagers() {
      axios.get(ORDERS_API_BASE + '/manager.php')
          .then(response => {
              this.managers = sortManagersByLabel(response.data);
          })
          .catch(error => {
              console.error('Ошибка при получении менеджеров:', error);
          });
    },

    openSidebar(taskid,duedata,tasktext,description, performer, taskorder, taskorderid) {
      this.isVisible = true;
      this.taskid = taskid;
      this.duedata = duedata;
      this.tasktext = tasktext;
      this.description = description;
      const performerData = JSON.parse(performer);
      this.performer = performerData.value;
      this.taskorder = taskorder;
      this.taskorderid = taskorderid;
    },
    close(){
      this.isVisible = false;
      this.selectedTaskId = null;
    },

async fetchTasks() {
  try {
    const labelid = this.$store.state.user.label;
    const id = this.$store.state.user.id;
    const userid = {
      "label": labelid,
      "value": String(id)
    };
    const useridJson = JSON.stringify(userid);

    // ВАЖНО: используем encodeURIComponent, чтобы кириллица и спецсимволы ({, }, ") не ломали GET-запрос
    const encodedUser = encodeURIComponent(useridJson);
    const response = await axios.get(`https://manager.1akb.by/getAllTasksManager/${encodedUser}`);
    
    if (response.status === 200) {
      // Нормализуем данные при получении
      this.tasks = response.data.map(task => {
        // Добавляем поле date в формате YYYY-MM-DD (требуется для MonthViewForTasks и currentDayTasks)
        if (task.dueDate && !task.date) {
          const datePart = task.dueDate.split(' ')[0]; // "31.03.2025"
          const parts = datePart.split('.');
          if (parts.length === 3) {
            task.date = `${parts[2]}-${parts[1]}-${parts[0]}`; // Делаем "2025-03-31"
          }
        }
        return task;
      });
      console.log('Полученные задачи:', this.tasks);
    }

  } catch (error) {
    console.error("Ошибка получения задач:", error);
  }
},

    parseFlatpickrDate(dateStr) {
    // Ожидается формат "d.m.Y H:i"
    const parts = dateStr.split(" ");
    if (parts.length < 2) return new Date(dateStr); // fallback
    const [d, m, y] = parts[0].split(".");
    const [h, i] = parts[1].split(":");
    return new Date(Number(y), Number(m) - 1, Number(d), Number(h), Number(i));
  },

async saveNewTask() {
  if (!this.newTaskText.trim() || !this.newTaskTitle.trim()) return;
  
  let newTaskDate =
    typeof this.selectedDateInput === "string"
      ? this.parseFlatpickrDate(this.selectedDateInput)
      : this.selectedDateInput;
  
  const formattedDate = this.formatDateToYMD(newTaskDate);
  const start_hour = newTaskDate.getHours() + (newTaskDate.getMinutes() >= 30 ? 0.5 : 0);
  
  const newTask = {
    id: Date.now() + Math.random(),
    order_id: this.droppedOrder ? this.droppedOrder.id : null,
    order_info: this.droppedOrder ? this.droppedOrder : null,
    title: this.newTaskTitle.trim(),
    text: this.newTaskText.trim(),
    date: formattedDate,
    start_hour: start_hour,
    duration: 0.5,
    completed: false,
    user_id: this.currentUser.id,
    user_label: this.currentUser.label,
    created_at: new Date().toISOString(),
    user: this.currentUser,
    startHour: start_hour,
    // Передаём новые поля
    phone: this.newTaskPhone,
    car: this.newTaskCar
  };
  
  try {
    const response = await axios.post("https://manager.1akb.by/addTask", newTask);
    if (response.status === 200) {
      this.tasks.push(newTask);
      this.closeAddModal();
    }
  } catch (error) {
    console.error("Ошибка при сохранении задачи:", error);
  }
},

   async saveEditedTask() {
  if (!this.editTaskText.trim() || !this.editTaskTitle.trim()) return;
  
  let editTaskDate =
    typeof this.editDateInput === "string"
      ? this.parseFlatpickrDate(this.editDateInput)
      : this.editDateInput;
  
  const formattedDate = this.formatDateToYMD(editTaskDate);
  const start_hour = editTaskDate.getHours() + (editTaskDate.getMinutes() >= 30 ? 0.5 : 0);

  const updatedTask = {
    id: this.editingTask.id,
    order_id: this.editingTask.order && this.editingTask.order.id ? this.editingTask.order.id : "",
    title: this.editTaskTitle.trim(),
    order_info: this.editTaskOrder || null, // Исправлено: убрано лишнее this.
    text: this.editTaskText.trim(),
    date: formattedDate,
    start_hour: start_hour,
    duration: this.editingTask.duration || 0.5,
    completed: this.editingTask.completed || false,
    user_id: this.editingTask.user ? this.editingTask.user.id : this.currentUser.id,
    user_label: this.editingTask.user ? this.editingTask.user.label : this.currentUser.label,
    user: this.editingTask.user || this.currentUser,
    startHour: start_hour
  };

  try {
    const response = await axios.post(`https://manager.1akb.by/updateTaskFields/`, updatedTask);
    if (response.status === 200) {
      Object.assign(this.editingTask, updatedTask);
      this.closeEditModal();
    }
  } catch (error) {
    console.error("Ошибка при обновлении задачи:", error);
  }
}
,

 getOrderField(task, field) {
  if (!task.order_info) {
    return '';
  }
  let orderInfo;
  if (typeof task.order_info === 'string') {
    try {
      orderInfo = JSON.parse(task.order_info);
    } catch (e) {
      console.error("Ошибка парсинга order_info:", e);
      return '';
    }
  } else {
    orderInfo = task.order_info;
  }
  return orderInfo && orderInfo[field] ? orderInfo[field] : '';
},
   async deleteTask(task) {
    if (!task.user_id || task.user_id !== this.currentUser.id) return;
    try {
      const response = await axios.delete(`https://manager.1akb.by/deleteTask/${task.id}`);
      if (response.status === 200) {
        this.tasks = this.tasks.filter(t => t.id !== task.id);
      }
    } catch (error) {
      console.error("Ошибка при удалении задачи:", error);
    }
  },
    async handleTaskDropped({ taskId, newDate, newStartTime }) {
      if (taskId.startsWith("order:")) {
  const orderId = taskId.slice(6);
  const orderIndex = this.orders.findIndex(o => String(o.id) === orderId);
  if (orderIndex !== -1) {
    const order = this.orders[orderIndex];
    this.selectedDate = newDate;
    this.selectedTime = newStartTime;
    let defaultDate = new Date(newDate);
    if (newStartTime !== undefined) {
      if (typeof newStartTime === "string") {
        const [hours, minutes] = newStartTime.split(":").map(Number);
        defaultDate.setHours(hours, minutes);
      } else if (typeof newStartTime === "number") {
        const hours = Math.floor(newStartTime);
        const minutes = (newStartTime % 1) ? 30 : 0;
        defaultDate.setHours(hours, minutes);
      }
    }
    this.selectedDateInput = defaultDate;
    this.newTaskText = "";
    this.newTaskTitle = "";
    
    // Присваиваем объект заказа и заполняем поля телефона и машины
    this.droppedOrder = order;
    this.newTaskPhone = order.phone || "";
    this.newTaskCar = order.car || "";
    
    this.modalAddVisible = true;
  }
}
 else {
        const newYMD = this.formatDateToYMD(newDate);
        const idx = this.tasks.findIndex(task => String(task.id) === String(taskId));
        if (idx !== -1) {
          const originalStart = this.tasks[idx].start_hour;
          // Если новое время не передано, оставляем исходное
          const updatedStartTime =
            newStartTime !== undefined && newStartTime !== null
              ? (typeof newStartTime === "string" ? this.parseTimeString(newStartTime) : newStartTime)
              : originalStart;
          this.tasks[idx].date = newYMD;
          this.tasks[idx].start_hour = updatedStartTime;
          this.tasks[idx].startHour = updatedStartTime;
          const updatedTask = {
            id: this.tasks[idx].id,
            order_id: this.tasks[idx].order && this.tasks[idx].order.id ? this.tasks[idx].order.id : "",
            title: this.tasks[idx].title || "",
            text: this.tasks[idx].text,
            date: newYMD,
            start_hour: updatedStartTime,
            duration: this.tasks[idx].duration || 0.5,
            completed: this.tasks[idx].completed || false,
            user_id: this.tasks[idx].user ? this.tasks[idx].user.id : this.currentUser.id,
            user_label: this.tasks[idx].user ? this.tasks[idx].user.label : this.currentUser.label,
            user: this.tasks[idx].user || this.currentUser,
            startHour: updatedStartTime
          };
          try {
            const response = await axios.post(`https://manager.1akb.by/updateTask/${updatedTask.id}`, updatedTask);
            if (response.status === 200) {
              this.$set(this.tasks, idx, updatedTask);
            }
          } catch (error) {
            console.error("Ошибка обновления задачи при перемещении:", error);
          }
        }
      }
    },
    switchView(mode) {
      this.viewMode = mode;
    },
    drillDownToDay(date) {
      this.currentDate = date;
      this.viewMode = "day";
    },
    selectDay(date) {
      this.currentDate = date;
    },
    goPrev() {
      const d = new Date(this.currentDate);
      if (this.viewMode === "month") {
        d.setMonth(d.getMonth() - 1);
      } else if (this.viewMode === "week") {
        d.setDate(d.getDate() - 7);
      } else {
        d.setDate(d.getDate() - 1);
      }
      this.currentDate = d;
    },
    goNext() {
      const d = new Date(this.currentDate);
      if (this.viewMode === "month") {
        d.setMonth(d.getMonth() + 1);
      } else if (this.viewMode === "week") {
        d.setDate(d.getDate() + 7);
      } else {
        d.setDate(d.getDate() + 1);
      }
      this.currentDate = d;
    },
    formatTime(num) {
      if (typeof num !== "number") return "";
      const hour = Math.floor(num);
      const minutes = num % 1 ? "30" : "00";
      return hour.toString().padStart(2, "0") + ":" + minutes;
    },
 formatDateToYMD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  },
  formatDateToYMDcustom(date) {
  const year = date.getFullYear();
  const day = date.getDate();
  const months = [
    'января', 'февраля', 'марта', 'апреля',
    'мая', 'июня', 'июля', 'августа',
    'сентября', 'октября', 'ноября', 'декабря'
  ];
  const month = months[date.getMonth()];
  return `${day} ${month} ${year} г.`;
},

    formatDate(ymd) {
      if (!ymd) return "";
      const [year, month, day] = ymd.split("-");
      return `${day}.${month}.${year.slice(-2)}`;
    },
    convertTimeNumberToTimeString(num) {
      if (typeof num !== "number") return "08:00";
      const hour = Math.floor(num);
      const minutes = num % 1 ? "30" : "00";
      return hour.toString().padStart(2, "0") + ":" + minutes;
    },
    parseTimeString(timeStr) {
      if (!timeStr) return 8;
      const [hour, minute] = timeStr.split(":").map(Number);
      return hour + (minute >= 30 ? 0.5 : 0);
    },
    openAddModal(date, time = null) {
      this.selectedDate = date;
      this.selectedTime = time;
      this.newTaskText = "";
      this.newTaskTitle = "";
      
      let defaultDateTime = new Date(date);
      if (time !== null) {
        if (typeof time === "string") {
          const [hours, minutes] = time.split(":").map(Number);
          defaultDateTime.setHours(hours, minutes);
        } else if (typeof time === "number") {
          const hours = Math.floor(time);
          const minutes = (time % 1) ? 30 : 0;
          defaultDateTime.setHours(hours, minutes);
        }
      }
      
      this.selectedDateInput = defaultDateTime;
      
      // Если задача создаётся перетаскиванием заказа, заполняем телефон и машину
      if (this.droppedOrder) {
        this.newTaskPhone = this.droppedOrder.phone || "";
        this.newTaskCar = this.droppedOrder.car || "";
      } else {
        this.newTaskPhone = "";
        this.newTaskCar = "";
      }
      
      this.modalAddVisible = true;
    },

async newOrder() {
  const formId = this.generateUniqueId();

  // Формируем объект данных формы
  const formOrder = {
    order: {
      id: formId,
      orderType: {label: "Физическое лицо", value: "eshop-individual"},
      site: {label: "Центральный офис 1akb.by", value: "1akb-by"},
      managerId: {
        label: this.user.label, // Передаём label
        value: this.user.id, // Передаём value
      },
      orderMethod: {},
      contragent:{
        contragentType:{ label: 'Физическое лицо', value: 'individual' },
      },
      
      
      products: [], // Пустой массив продуктов
      comments: {
        customerComment: '',
        managerComment: '',
      },
      shipment: {
        shipmentDate: null,
        deliveryCost: null,
        deliveryAddress: '',
        deliveryDate: null,
        weight: null,
        dimensions: {
          length: null,
          width: null,
          height: null,
        },
      },
      deliveryTime: {
        from: null,
        to: null,
      },
      customTime: null,
      oneTimeDiscountAmount: null,
      oneTimeDiscountPercent: null,
    }
  };

  // Сохраняем форму через Vuex
  //this.saveForm(formData);
  try {
                    const response = await axios.post(ORDERS_API_BASE + '/saveCallOrder.php', formOrder);
                        if (response.data.success) {
                            const { orderId, numberOrder, orderSite, orderCreated } = response.data;
                            
                            const formData = { id:orderId, idorder:orderId, number:numberOrder, site: orderSite ? orderSite : {label: "Центральный офис 1akb.by", value: "1akb-by"}, created:orderCreated, orderMethod:{label:null,value: null}};
                            this.loading = false;
                            alert('Заказ успешно созданнн!');
                            this.$store.dispatch('savedFormsModule/clearSavedForms');
                            this.$store.commit('clearProducts'); // Очистка продуктов через Vuex мутацию
                            this.saveForm(formData);
                            this.$router.push({ name: 'OrderEdit', params: { orderId, site: orderSite } });
                        } else {
                            this.loading = false;
                            alert('Ошибка при создании заказа: ' + response.data.message);
                        }
                    } catch (error) {
                        console.error('Ошибка при создании заказа:', error);
                        alert('Произошла ошибка при создании заказаffff.');
                        this.loading = false;
                    }
  /*console.log(
    `Форма с номером телефона ${phone} успешно сохранена. Источник: ${source.label} (${source.value})`
  );*/
},

openServiceModal() {
    // При открытии копируем текущий выбор в временный массив (если требуется)
    this.tempSelectedServices = [...this.selectedServices];
    this.serviceModalVisible = true;
  },
  closeServiceModal() {
    this.serviceModalVisible = false;
  },
 confirmServices() {
      this.selectedServices = [...this.tempSelectedServices];
      this.serviceModalVisible = false;
    },
    toggleService(serviceId) {
      // Переключаем состояние раскрытия для данной категории
      this.$set(this.expandedServices, serviceId, !this.expandedServices[serviceId]);
    },
    isExpanded(serviceId) {
      return !!this.expandedServices[serviceId];
    },
   closeAddModal() {
      this.modalAddVisible = false;
      this.selectedDateInput = new Date();
      this.newTaskText = "";
      this.selectedServices = "";
      this.newTaskTitle = "";
      this.droppedOrder = null;
    },
    // Метод для открытия модального окна нового заказа
    openNewOrderModal() {
      // Сброс значений формы нового заказа (если требуется)
      this.newOrderTitle = "";
      this.newOrderDateInput = new Date();
      this.newOrderPhone = "";
      this.newOrderCar = "";
      this.newOrderComment = "";
      this.modalNewOrderVisible = true;
    },
    closeNewOrderModal() {
      this.selectedServices = "";
      this.newOrderTitle = "";
      this.newOrderDateInput = new Date();
      this.newOrderPhone = "";
      this.newOrderCar = "";
      this.newOrderComment = "";
      this.modalNewOrderVisible = false;
    },

    // Обработчик сохранения нового заказа
    async saveNewOrder() {
      // Собираем данные нового заказа
      const order = {
        order: {
          car: this.newOrderCar.trim(),
          managerComment: this.newOrderComment.trim(),
          customer:{phone: this.newOrderPhone.trim(),firstName:this.newOrderName.trim()},
          site: 'sto-prodaza',
          orderMethod: 'sto32',
          shipmentStore: 'sto',
          orderType:'eshop-individual',
          managerId: this.currentUser.id,
          contragent: {contragentType: "individual"},
          // Дополнительно можно передать выбранные услуги, если нужно
          services: this.selectedServices
        }
      };

      try {
        // Пример отправки данных на обработчик (замените URL на реальный endpoint)
        const response = await axios.post(ORDERS_API_BASE + "/orderSto.php", order);
        if (response.status === 200) {
          // Обработка успешного ответа
          alert("Новый заказ успешно создан!");
          this.closeNewOrderModal();
        }
      } catch (error) {
        console.error("Ошибка при сохранении нового заказа:", error);
      }
    },

       // Метод для получения названия статуса по коду
    getStatusName(code) {
      const status = this.statuses.find(s => s.code === code);
      return status ? status.name : code;
    },
    // Пример метода для получения цвета (можно настроить под вашу логику)
    getStatusColor(code) {
      const status = this.statuses.find(s => s.code === code);
      return status ? status.color : '#fff';
    },
  openEditModal(task) {
      this.editingTask = task;
      this.editTaskText = task.text;
      
      // Проверяем, что order_info существует
      if (task.order_info) {
        // Если order_info – строка, пытаемся его распарсить
        if (typeof task.order_info === "string") {
          try {
            this.editTaskOrder = JSON.parse(task.order_info);
          } catch (e) {
            console.error("Ошибка парсинга order_info:", e);
            this.editTaskOrder = {};
          }
        } else {
          // Если это уже объект, просто присваиваем его
          this.editTaskOrder = task.order_info;
        }
      } else {
        this.editTaskOrder = {};
      }

      this.editTaskTitle = task.title || "";
      
      // Преобразуем строку даты в объект Date
      let taskDate = new Date(task.date);
      // Если задано время выполнения, устанавливаем часы и минуты
      if (task.start_hour !== undefined) {
        const hours = Math.floor(task.start_hour);
        const minutes = (task.start_hour % 1) ? 30 : 0;
        taskDate.setHours(hours, minutes);
      }
      this.editDateInput = taskDate;
      this.modalEditVisible = true;
    },
    closeEditModal() {
      this.modalEditVisible = false;
      this.editingTask = null;
      this.editTaskText = "";
      this.editTaskTitle = "";
      this.editTaskOrder = "";
      this.editDateInput = "";
      this.editTaskTimeInput = "08:00";
    },
    filterByStatus(statusValue) {
      this.activeStatus = statusValue;
      this.fetchOrders();
    },
    fetchOrders() {
      const filterParams = { sites: ["sto-prodaza"] };
      if (this.activeStatus) {
        filterParams.extendedStatus = [this.activeStatus];
      }
      axios
        .get(this.apiEndpoint, {
          params: {
            page: this.page,
            per_page: this.perPage,
            filter: filterParams
          }
        })
        .then(response => {
          if (response.data.orders) {
            this.orders = response.data.orders;
          } else {
            console.error("Ошибка получения заказов", response.data);
          }
        })
        .catch(error => {
          console.error("Ошибка запроса к API", error);
        });
    },
    onDragStartFromList(e, order) {
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("text/plain", "order:" + String(order.id));
    },

    getStatusColor(status) {
      switch (status) {
        case "completed":
          return "#28a745";
        case "overdue":
          return "#dc3545";
        case "pending":
          return "#fd7e14";
        default:
          return "#6c757d";
      }
    },
    handleDaysBodyWheel(e) {
      e.preventDefault();
      if (e.deltaY > 0) {
        this.goNext();
      } else if (e.deltaY < 0) {
        this.goPrev();
      }
    }
  },
  mounted() {
    this.fetchOrders();
    this.fetchTasks();
  }
};
</script>





<style scoped>


.neword {
  margin-bottom: 20px;
  width: 100%;
  margin-left: 0;
}
.neword:hover {
  color: #fff;
  background: #3d3d3d;
}
.erorp{
  color: red;
  float: right;
}

.orderid,
.duedat {
  font-size: 11px;
}
.duedat {
  color: #abaaaa;
}
.bubble-cont div {
  font-weight: bold;
}
.sidebar-panel {
    background: #f4f6f8;
    display: flex;
    padding: 8px 32px;
}


.sidebar-body__inner {
    padding: 20px 32px;
}

.bubble-item__row {
    display: flex;
    margin-top: 8px;
}

.buble-info{
    align-items: center;
    display: flex;
    margin-left: 16px;
}
.buble-info svg {
    fill: #c7cdd4;
    height: 20px;
    margin-right: 4px;
    width: 20px;
}
.buble-info:first-child {
    margin-left: 0px;
}
.bubble-item__body {
    background: #edf4ff;
    padding: 10px;
    margin: 10px;
    border-radius: 10px;
    width: 100%;
    transition: 0.3s;
    cursor: pointer;
}
.bubble-item__body:hover {
  background: #eee;
}

.bubble-item__comment svg {
    fill: #c7cdd4;
    height: 20px;
    margin-left: 11px;
    transform: translateY(3px);
    transition: .2s ease;
    width: 20px;
    position: relative;
    top: -2px;
    vertical-align: top;
}
.bubble-cont {
    display: flex;
}

.taskitem {
    display: flex;
    align-items: center;
}
.dueData {
    text-align: center;
    color: #636f7f;
}

.icontask svg {
    fill: #c7cdd4;
    cursor: pointer;
    height: 24px;
    transition: .2s ease;
    width: 24px;
}
.icontask.act svg {
    fill: #22c993;
}
.icontask:hover svg {
    fill: #636f7f;
}

.bubble-cont .complited {
    color: #afb9c3;
    text-decoration: line-through;
}




/* Стили для инпутов и select */
.app-input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 14px;
  margin-bottom: 5px;
  width: 100%;
  box-sizing: border-box;
  height: 44px;
}

/* Стили для меток */
label {
  margin-bottom: 4px;
    display: block;
    font-size: 12px;
    font-style: normal;
    line-height: 1.2;
    padding: 6px 10px 0 0;
    color: #636f7f;
    min-width: 158px;
    max-width: 158px;
    margin-right: 5px;
}



/* Стили для textarea */
.custom-modal__textarea {
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 3px;
  resize: vertical;
  min-height: 80px;
  font-size: 14px!important;
}

/* Стили для кнопок модального окна */
.custom-modal__btn {
  padding: 6px 12px;
  background-color: #007bff;
  border: none;
  border-radius: 3px;
  color: #fff;
  cursor: pointer;
  margin-right: 0px;
}

.custom-modal__btn--cancel {
  background-color: #6c757d;
}

/* Стили для overlay модального окна */
.custom-modal__overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Стили для модального окна */
.custom-modal {
  background: #fff;
  border-radius: 5px;
  width: 400px;
  max-width: 90%;
}

/* Общий контейнер приложения */
.calendar-app {
  display: flex;
  height: 100vh;
  width: 100%;
 
}

/* ====== Сайдбар (левая колонка) ====== */
.sidebar {
  width: 320px;
  background: #ffffff;
  border-right: 0px solid #dee2e6;
  padding: 20px;
  overflow-y: auto;
}

/* Стили для вкладок */
.tabs {
  display: flex;
  margin-bottom: 20px;
}

.tabs button {
     flex: 1;
    padding: 6px;
    border: none;
    background: transparent;
    cursor: pointer;
    font-weight: bold;
    font-size: 16px;
}

.tabs button.active {
  border-bottom: solid 1px;
}

/* --- Блок Калькуляции --- */
.calculation-block {
  margin-bottom: 20px;
}

/* Заголовок "Калькуляция (3) ... ₽" */
.calculation-header {
  display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding: 0px 5px;
}
.calculation-title {
    font-size: 14px;
    font-weight: 800;
    color: #333;
    margin-bottom: 5px;
    
}

.label_span {
  font-size: 10px;
    color: #8e8e8e;
    font-weight: 400;
    display: block;
    width: 100%;
}
.calculation-total {
  font-size: 14px;
  font-weight: normal;
  color: #333;
}

/* Список карточек задач (на сегодня) */
.calculation-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.calculation-item {
border-bottom: 1px solid #e6e6e6;
    border-radius: 0px;
    background: #fff;
    padding: 5px 5px;
    margin-bottom: 1px;
    position: relative;
    cursor: pointer;
    transition: transform 0.2s;
}
.calculation-item:hover {
  transform: translateY(-1px);
  background: #fcfcfc;
}

/* Верхняя часть карточки (авто + госномер и организация) */
.calculation-item-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1px;
}
.calculation-car-model {
  font-weight: 600;
  font-size: 14px;
  color: #444;
}
.calculation-plate {
  margin-left: 5px;
  color: #888;
  font-size: 13px;
}
.calculation-organization {
  font-size: 10px;
   color: #c4c4c4;
    font-weight: 400;
}

/* Основной блок: дата/время, телефон, комментарий */
.calculation-item-body {
  display: flex;
  flex-direction: column;
  gap: 0px;
  margin-bottom: 6px;
}
.calculation-date {
  font-size: 10px;
    color: #c4c4c4;
    font-weight: 400;
}
.calculation-phone a {
  font-size: 12px;
  color: #007bff;
  text-decoration: none;
}
.calculation-phone a:hover {
  text-decoration: underline;
}
.calculation-comment {
  font-size: 12px;
  color: #555;
  line-height: 1.3;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Стоимость (в правом нижнем углу карточки) */
.calculation-cost {
  font-weight: 700;
  font-size: 14px;
  color: #333;
  text-align: right;
}

/* Кнопка удаления (икс) */
.calculation-delete {
     position: absolute;
    top: 0px;
    right: -16px;
    font-size: 16px;
    color: #dc3545;
    cursor: pointer;
}

/* --- Блок заказов (фильтры + карточки) --- */
.orders-list {
  margin-top: 20px;
}
.orders-list h3 {
 font-weight: 800;
    font-size: 16px;
}
.filter-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}
.filter-buttons button {
  padding: 4px 8px;
  font-size: 10px;
  border: 1px solid #007bff29;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  transition: background 0.3s;
}
.filter-buttons button.active {
  background: #007bff;
  color: #fff;
}

/* Сетка карточек заказов */
.orders-grid {
    display: flex;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    flex-wrap: wrap;
}
.order-card {
background: #ffffff;
    border-bottom: 0px solid #ced4da;
    border-radius: 0px;
    padding: 0px;
    cursor: grab;
    transition: box-shadow 0.2s;
    width: 100%;
}
.order-card:hover {
  box-shadow: 0 4px 6px rgba(0,0,0,0.15);
}
.order-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
}
.order-phone {
      font-size: 12px;
    font-weight: 800;
    color: #212529;
}
.order-status {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 12px;
  color: #fff;
  text-transform: uppercase;

}
.order-card-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.order-number {
  font-size: 10px;
  color: #6c757d;
}
.order-comment {
  font-size: 12px;
  color: #495057;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.order-car {
  font-size: 12px;
  color: #6c757d;
}

.order-comment {

  display: none;
}

/* ====== Правая часть – календарь ====== */
.calendar-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.calendar-header {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    padding: 10px;
    border-left: 1px solid #cfd8dc;
}
.header-btn {
  color: #000;
    border: none;
    padding: 8px 12px;
    margin: 0 4px;
    border-radius: 0px;
    cursor: pointer;
    transition: background 0.3s;
    width: 100px;
    background: #ffefbf;
}
.header-btn.active {
  background: #357ABD;
  color: #ffffff;
}
.nav-btn {
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
}
.header-current {
  font-size: 16px;
  font-weight: bold;
}

.custom-modal__info_sto{
  background: #f7f6f6;
    padding: 10px;
    font-size: 14px;
    line-height: 14px;
    margin-top: 20px;
    border-radius: 4px;
}

.custom-modal__info {
  width: 100%;
}


.form_date_block {
  display: flex;
    gap: 10px;
    margin: 10px 0px;
}


.flatpickr-day.selected {
  background: #0052ca;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #fff;
    border-color: #0052ca;
}

/* Модальные окна */
.custom-modal__overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
.custom-modal {
  background: #fff;
  border-radius: 12px;
  width: 500px;
  max-width: 95%;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
  overflow: hidden;
  transform: translateY(-20px);
  animation: slideDown 0.3s forwards;
}
@keyframes slideDown {
  from { transform: translateY(-20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
.custom-modal__header {
  background: rgba(255, 220, 40, 0.15);
  padding: 20px;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.custom-modal__content {
  padding: 20px;
  font-size: 16px;
  color: #333;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.custom-modal__textarea {
  width: 95%;
  height: 100px!important;
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  resize: vertical;
  transition: border-color 0.2s;
}
.custom-modal__textarea:focus {
  border-color: #0052cc;
  outline: none;
}
.custom-modal__footer {
  background: #f7f7f7;
  padding: 15px 20px;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}
.custom-modal__btn {
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: #fff;
  transition: background 0.2s;
}
.calculation-title-header {
  font-weight: 800;
    font-size: 16px;
}
.custom-modal__btn:not(.custom-modal__btn--cancel) {
  background: #0052cc;
}
.custom-modal__btn:hover {
  transform: translateY(-2px);
}
.custom-modal__btn--cancel {
  background: #e0e0e0;
  color: #333;
}
.custom-modal__btn--cancel:hover {
  background: #d5d5d5;
}

.header-main{
    display: flex;
    empty-cells: hide;
    padding: 32px 0 24px;
    justify-content: space-between;
}




.header-main .hm-left {
    width: auto;
}

.header-main .hm-left, .header-main .hm-right {
    display: table-cell;
    float: none;
    vertical-align: top;
}





.hm-left h1 {
    font-size: 24px;
    font-weight: 500;
    letter-spacing: -.3px;
    line-height: 32px;
    margin-top: 10px;
}

.header-main__title:not(:last-child) {
    margin-right: 16px;
}


.btn_ms {
    margin-right: 10px;
    background: linear-gradient(180deg, #fea530, #e48e1e) !important;
    color: #ffffff;
    font-size: 14px;
    height: 24px;
    line-height: 24px;
    padding: 12px 24px;
}


.btn_md{
    font-size: 14px;
    height: 25px;
    line-height: 24px;
    padding: 12px 24px;
}


.btn-content {
    display: flex;
}

.btn-content_icon {
    margin-left: -8px;
}


.btn_ms.router-link-exact-active {
    margin-right: 0px;
    background: linear-gradient(180deg, #d4d4d4, #e6e6e6) !important;
    color: #000000;
    font-size: 14px;
    height: 24px;
    line-height: 24px;
    padding: 12px 24px;
}


.order-card {
  position: relative;
  /* остальные стили карточки */
}

.tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  transform: translateY(5px);
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 8px 12px;
  border-radius: 4px;
  white-space: normal;
  font-size: 12px;
  line-height: 1.3;
  z-index: 100;
  display: none;
  width: 250px; /* задайте нужную ширину */
}

::v-deep .order-card:hover .tooltip {
  display: block;
}



.calculation-block-zakaz {
       display: flex;
    gap: 20px;
    background: #f4f6f8;
}

.calculation-comment div {
  white-space: pre-line;
}


.block_zakaz{
    border-left: solid 1px rgb(255 255 255 / 95%);
    padding-left: 5px;
}

.block_zakaz .label_span {
  font-size: 10px;
  color: #8e8e8e;
  font-weight: 400;
}


.block_zakaz div {
  font-weight: 700;
  font-size: 12px;
}


ul {
  list-style: none;
  padding-left: 0px;
}

.sto label {
  min-width: 100%;
  max-width: 100%;
}


.custom-modal__btn.sto {
    position: absolute;
    top: 80px;
    right: 20px;
    border: solid 1px #e0dcc4;
    background: #fef9de;
    padding: 10px 15px;
}

.custom-modal__btn.sto svg {
      width: 28px;
     height: 28px;
}




.btn-content:before {
    content: "";
    height: 20px;
    margin-right: 8px;
    width: 20px;
}


.btn-content_icon:before {
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 100%;
    float: none !important;
    margin-left: 0 !important;
    top: 0 !important;
}



.btn-content_new:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23FFF' fill-rule='evenodd' d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm1-9h2.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H13v2.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V13H8.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H11V8.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V11Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.btn_md .btn-content_icon:before, .btn_min-icon {
    height: 24px;
    width: 24px;
}

.btn-content_new {

    font-size: 16px;
    height: 25px;
    line-height: 24px;
    padding: 12px 24px;

    background: none;
    background-color: #005eeb;
    background-image: linear-gradient(180deg, #0068ff, #005bd5);
    border: none;
    border-radius: 6px;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
    font-size: 14px;
    font-weight: 500;
    height: 32px;
    line-height: 20px;
    padding: 8px 20px;
    text-decoration: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    vertical-align: middle;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 125px;
}

.btn-wrapper.btn-wrapper_group.new {
  display: flex;
}


.custom-modal.new_order .custom-modal__header {
    background: rgb(0 82 203);
    padding: 20px;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    color: #fff;
}


.custom-modal.new_order .custom-modal__btn.sto{
    position: absolute;
    top: 80px;
    right: 20px;
    border: solid 1px #003e98;
    background: #0052ca;
    padding: 10px 15px;
}

.calculation-block-zakaz-sto {
    display: flex;
    gap: 1px;
    margin-top: 0px;
    background: #f4f6f8;
    flex-wrap: wrap;
    height: auto;
    padding: 12px 0px;
}

.calculation-block-zakaz-sto .block_zakaz {
    border-left: solid 1px rgb(221 221 221);
    padding-left: 5px;
    width: 47%;
}


.block_zakaz_all {
    width: 100%;
    border-top: solid 1px #dddddd;
    margin-top: 5px;
     padding-left: 5px;
}


.block_zakaz_all  div {
    font-weight: 700;
    font-size: 12px;
}

.block_zakaz_all_select {
    width: 96.5%;
    padding: 5px;
    background: #4b4b4b12;
    margin-top: 5px;
    padding-top: 5px;
}


.block_zakaz_all_select .label_span {
  margin-bottom: 5px;
}

.fllink {
  display: flex;
}

.bubble-item__row:hover .orderid {
  text-decoration: underline;
  color: #000;
  font-weight: bold;
}
</style>
